import reducer from "./reducers";

import * as asignacionesOps from "./operations";
import * as asignacionesTypes from "./types";

export { asignacionesOps, asignacionesTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/asignaciones/index.js